import React from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import Item from "./Item";
import Eng from "../../Assets/eng.png";
import Eng1 from "../../Assets/eng1.png";
import Eng2 from "../../Assets/eng2.png";
import Step from "./Step";
import Plan from "./Plan";

const Home = () => {
  return (
    <div className="home">
      <div className="consultation">
        <div>
          <div className="left">
            <div className="header">Expert CDR Report Writing Services for Engineers Seeking Migration to Australia</div>
            <div className="desc">
              Ensure Your CDR Report Gets Approved by Engineers Australia with Our Professional Assistance. Quick, Dependable, and Customized for Migration Success!
            </div>
            <div className="buttons">
              <a href="https://api.whatsapp.com/send?phone=61488877505">Talk to Expert</a>
              <a href="https://api.whatsapp.com/send?phone=61488877505">Check Samples</a>
            </div>
          </div>
          <div className="right">
            <div className="title">Get Free Consultation</div>
            <div className="input">
              <label>Name</label>
              <input placeholder="Enter your name" type="text" />
            </div>
            <div className="input">
              <label>Email</label>
              <input placeholder="Enter your email" type="text" />
            </div>
            <div className="input">
              <label>Phone</label>
              <input placeholder="Enter your phone" type="text" />
            </div>
            <div className="input">
              <label>Message</label>
              <textarea placeholder="Enter your message" />
            </div>
            <a href="https://api.whatsapp.com/send?phone=61488877505">Free Consultation</a>
          </div>
        </div>
      </div>
      <div className="services">
        <div>
          <div className="header">Our Services</div>
          <div className="service">
            <div className="details">
              <div className="header">CDR Writing Services</div>
              <div className="desc">
                Comprehensive CDR Report Package for Engineers Seeking Migration Skill Assessment – Expertly crafted reports with guidance from top professionals.
              </div>
              <div className="items">
                <Item type={0} amount="490+" text="Successful CDR Written" />
                <Item type={1} amount="98%" text="Success Rate of Assessment" />
                <Item type={2} amount="30+" text="Engineering Professionals" />
              </div>
              <Link className="learn" to={"/cdrwriting"}>
                Learn More
              </Link>
            </div>
            <img src={Eng} alt="Engineering" />
          </div>
          <div className="service">
            <img src={Eng1} alt="Engineering" />
            <div className="details">
              <div className="header">ACS RPL Report Writing</div>
              <div className="desc">
                Receive professional assistance with your Recognition of Prior Learning (RPL) report for ICT backgrounds, specifically designed to align with ACS Australia’s Key
                Areas of Knowledge and project report criteria.
              </div>
              <div className="items">
                <Item type={0} amount="290+" text="Successful RPL Written" />
                <Item type={1} amount="92%" text="Success Rate of Assessment" />
                <Item type={2} amount="23+" text="IT Professionals" />
              </div>
              <Link to={"/acsrplreportwriting"}>Learn More</Link>
            </div>
          </div>
          <div className="service">
            <div className="details">
              <div className="header">KA02 Writing Services</div>
              <div className="desc">
                ICT professionals require the KA02 report to demonstrate their skills and work experience to IPENZ as part of the New Zealand Skilled Migration process. Rely on our
                expertise for a high success rate in securing approval from IPENZ.
              </div>
              <div className="items">
                <Item type={0} amount="140+" text="Successful KAO2 Written" />
                <Item type={1} amount="99%" text="Success Rate of Assessment" />
                <Item type={2} amount="30+" text="Engineering Professionals" />
              </div>
              <Link to={"/ka02rportwriting"}>Learn More</Link>
            </div>
            <img src={Eng2} alt="Engineering" />
          </div>
        </div>
      </div>
      <div className="contact">
        <div>
          <div className="top">Have a question? Give us a call on</div>
          <div className="phone">+61 488 877 505</div>
          <div className="desc">Interested in learning about our services? Enjoy a free consultation on migration skill assessments and connect directly with our experts.</div>
          <a href="https://api.whatsapp.com/send?phone=61488877505">Chat with us</a>
        </div>
      </div>
      <div className="steps">
        <div>
          <div className="header">Steps To Follow</div>
          <div className="items">
            <Step
              step={1}
              title="Submit Your Query"
              desc="To begin, submit your request by simply filling out the submission form; you can also speak with our agent directly via chat. Make sure you provide all of the information and descriptions required for the CDR report."
            />
            <Step
              step={2}
              title="Provide Partial Deposit"
              desc="After you submit the form, you will be assigned to one of our expert agents in the field related to your ANZSCO occupation. You can discuss about your project completed and other requirements with the writers. Then, deposit a portion of the order as stated on the pricing detail"
            />
            <Step
              step={3}
              title="Sample Copy of the Report"
              desc="We give you a draft sample copy of the respective report as soon as it is finished for clarification and confirmation. Examine all of the information carefully and indicate any adjustments you’d like us to make to the report."
            />
            <Step
              step={4}
              title="Receive Your Final Report"
              desc="Ultimately, we will give you the finest quality, plagiarism-free report on time. You now have the option of checking and verifying the report again for your satisfaction. Based on the review, you can request additional updates or improvements based on your needs."
            />
          </div>
        </div>
      </div>
      <div className="pricingPlan">
        <div>
          <div className="header">Price Plan</div>
          <div className="items">
            <Plan title="Standard Plan" price={699} get={["1 CPD", "3 Career Episode", "1 Summary Statement", "Plagiarism Free"]} />
            <Plan title="Premium Plan" price={1399} get={["1 CPD", "3 Career Episode", "1 Summary Statement", "Plagiarism Free", "After Service Support"]} />
            <Plan title="Royal Plan" price={2599} get={["1 CPD", "3 Career Episode", "1 Summary Statement", "Plagiarism Free", "After Service Support", "Project Report"]} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
